module.exports = __webpack_public_path__ + "img/Frame 4@2x.a0bf2ec9.png";